<div class="flex flex-col">
  <div class="grid grid-cols-2 gap-2 items-center">
    <div>
      <div *ngIf="!addingHistory" class="flex flex-col md:flex-row gap-1">
        <span class="font-semibold">Residential</span>
        <span class="font-semibold">History</span>
      </div>
      <span *ngIf="addingHistory && history.id === 0" class="font-semibold">Add An Entry</span>
      <div *ngIf="addingHistory && history.id > 0" class="flex flex-col md:flex-row gap-1">
        <span class="font-semibold">Update</span>
        <span class="font-semibold">History</span>
      </div>

    </div>
    <div class="gap-1 flex justify-self-end items-center">
      <span *ngIf="fullHistory.length > 0 && !addingHistory">Click Entry to Manage</span>

      <button type="button" *ngIf="!addingHistory"
              mat-button color="primary" (click)="toggleHistoryForm(true)">Add</button>

      <button type="button" *ngIf="!addingHistory"
              mat-button color="primary" (click)="getHistory(!includeArchived)">{{includeArchived? 'Hide Archived' : 'Show Archived'}}</button>

      <button type="button" *ngIf="addingHistory && historyForm.valid && history.id === 0"
              mat-button color="primary" (click)="createHistory()">Save</button>

      <button type="button" *ngIf="addingHistory && historyForm.valid && history.id > 0 && !locked"
              mat-button color="primary" (click)="saveHistory()">Save</button>

      <button type="button" *ngIf="addingHistory && history.id > 0"
              mat-button color="warn" (click)="archiveHistory(history, !history.archived)">{{ history.archived? 'Un-Archive' : 'Archive' }}</button>

      <button type="button" *ngIf="addingHistory"
              mat-button color="warn" (click)="toggleHistoryForm(false)">Close</button>
    </div>
  </div>

  <div *ngIf="!addingHistory" class="md:mt-1">
    <mat-table [dataSource]="historySource" matSort #HistorySort="matSort" aria-describedby="Residential History" class="mat-elevation-z8">
      <ng-container matColumnDef="city">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">City</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let history">
          <span class="mobile-label">City</span>
          {{ history.city }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="state">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">State</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let history">
          <span class="mobile-label">State</span>
          {{ history.state }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="country">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Country</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let history">
          <span class="mobile-label">Country</span>
          {{ history.country }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="from">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">From</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let history">
          <span class="mobile-label">From</span>
          {{ history.from | date: 'MMM yyyy' }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="to">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">To</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let history">
          <span class="mobile-label">To</span>
          {{ history.to | date: 'MMM yyyy' }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="archived">
        <mat-header-cell *matHeaderCellDef>Archived</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let history">
          <span class="mobile-label">Archived</span>
          <span>{{ history.archived? 'Yes' : 'No' }}</span>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="historyColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: historyColumns" class="hover:bg-gray-500 hover:bg-opacity-25"
               [ngClass]="row.archived? 'bg-red-100 bg-opacity-25 text-black' : ''" (click)="selectHistory(row)"></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" #HistoryPaginator="matPaginator">
    </mat-paginator>
  </div>

  <div *ngIf="addingHistory" class="md:mt-2">
    <form [formGroup]="historyForm">
      <div class="flex flex-col gap-2">
        <div class="flex flex-col md:flex-row gap-2">
          <mat-form-field class="md:w-1/3">
            <mat-label>City</mat-label>
            <input matInput formControlName="city">
            <mat-error *ngIf="historyForm.get('city').invalid">
              City is required
            </mat-error>
          </mat-form-field>
          <mat-form-field class="md:w-1/3">
            <mat-label>State</mat-label>
            <mat-select formControlName="state">
              <mat-option value="N/A">N/A</mat-option>
              <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
            </mat-select>
            <mat-error *ngIf="historyForm.get('state').invalid">
              You must select an option
            </mat-error>
          </mat-form-field>
          <mat-form-field class="md:w-1/3">
            <mat-label>Country</mat-label>
            <input matInput formControlName="country">
            <mat-error *ngIf="historyForm.get('country').invalid">
              Country is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="flex flex-col md:flex-row gap-2">
          <div class="flex flex-col md:w-1/2">
            <div class="flex h-10 items-center">
              <span class="font-semibold">From</span>
            </div>
            <mat-form-field>
              <mat-label>From Month and Year</mat-label>
              <input placeholder="mm/yyyy" matInput [matDatepicker]="from" formControlName="from" [max]="sharedService.today" (blur)="dateChange($event, 'from')">
              <mat-hint>MM/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
              <mat-datepicker #from startView="multi-year" (monthSelected)="setMonthAndYear($event, from, 'from')">
              </mat-datepicker>
              <mat-error *ngIf="historyForm.get('from').invalid">
                From date is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-col md:w-1/2">
            <div class="flex h-10 items-center">
              <span class="font-semibold">Date of Birth</span>
            </div>
            <mat-form-field>
              <mat-label>To Month and Year</mat-label>
              <input placeholder="mm/yyyy" matInput [matDatepicker]="to" formControlName="to" [max]="sharedService.today" (blur)="dateChange($event, 'to')">
              <mat-hint>MM/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
              <mat-datepicker #to startView="multi-year" (monthSelected)="setMonthAndYear($event, to, 'to')">
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
